import { render, staticRenderFns } from "./BeginningInventoriesSearch.vue?vue&type=template&id=c6403588&scoped=true&"
import script from "./BeginningInventoriesSearch.vue?vue&type=script&lang=js&"
export * from "./BeginningInventoriesSearch.vue?vue&type=script&lang=js&"
import style0 from "./BeginningInventoriesSearch.vue?vue&type=style&index=0&id=c6403588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6403588",
  null
  
)

export default component.exports